import { assignInlineVars } from '@vanilla-extract/dynamic';
import { Property } from 'csstype';

import { ComponentPropsWithoutStyles } from '@/util/ComponentPropsWithoutStyles';

import * as styles from './column.css';

export interface ColumnProps extends ComponentPropsWithoutStyles<
  React.HTMLAttributes<HTMLDivElement>
> {
  justifyContent?: Property.JustifyContent;
  alignItems?: Property.AlignItems;
  spacing?: Exclude<Property.Gap, 0>;
  width?: Exclude<Property.Width, 0>;
  minWidth?: Exclude<Property.MinWidth, 0>;
  maxWidth?: Exclude<Property.MaxWidth, 0>;
}

export const Column = ({
  justifyContent,
  alignItems,
  spacing,
  width,
  minWidth,
  maxWidth,
  children,
}: ColumnProps) => (
  <div
    className={styles.root}
    style={{
      ...assignInlineVars({
        [styles.justifyContentVar]: justifyContent ?? 'start',
        [styles.alignItemsVar]: alignItems ?? 'center',
        [styles.spacingVar]: spacing ?? '0',
        [styles.widthVar]: width ?? 'unset',
        [styles.minWidthVar]: minWidth ?? 'unset',
        [styles.maxWidthVar]: maxWidth ?? 'unset',
      }),
    }}
  >
    {children}
  </div>
);
